import { S3Client, DeleteObjectCommand } from '@aws-sdk/client-s3';

export const s3 = new S3Client({
  region: process.env.NEXT_PUBLIC_AWS_REGION!,
  credentials: {
    accessKeyId: process.env.NEXT_PUBLIC_AWS_ACCESS_KEY_ID!,
    secretAccessKey: process.env.NEXT_PUBLIC_AWS_SECRET_ACCESS_KEY!
  }
});

export const deleteFromS3 = async (url: string) => {
  try {
    const { bucket, key } = (() => {
      try {
        const parsed = new URL(url);
        const bucket = 'seesight-tours-reviews';
        const key = decodeURIComponent(
          parsed.pathname[0] === '/'
            ? parsed.pathname.slice(1)
            : parsed.pathname
        );
        return { bucket, key };
      } catch (err) {
        console.error('Error parsing S3 URL:', err);
        return {
          bucket: process.env.NEXT_PUBLIC_AWS_BUCKET_NAME || '',
          key: ''
        };
      }
    })();

    if (!bucket || !key) {
      throw new Error('Invalid S3 URL or missing bucket/key');
    }
    const region = 'us-east-2';
    const endpoint = `https://s3.${region}.amazonaws.com`;
    const s3 = new S3Client({
      region,
      endpoint,
      forcePathStyle: false,
      credentials: {
        accessKeyId: process.env.NEXT_PUBLIC_AWS_ACCESS_KEY_ID || '',
        secretAccessKey: process.env.NEXT_PUBLIC_AWS_SECRET_ACCESS_KEY || ''
      }
    });
    const deleteCommand = new DeleteObjectCommand({
      Bucket: bucket,
      Key: key
    });

    await s3.send(deleteCommand);
    return true;
  } catch (error) {
    console.error('Error deleting from S3:', error);
    return false;
  }
};
